import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function EditSubcategoria({ history, match }) {
  const dispatch = useDispatch();

  const modelEditSubcategoria = useSelector(
    (state) => state.updateSubcategoria
  );
  const modelServicioById = useSelector((state) => state.servicioById);

  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [servicioId, setServicioId] = useState(match.params.id);

  useEffect(() => {
    dispatch(controller.servicioByIdThunk(match.params.id));
  }, []);

  useEffect(() => {
    const data = modelEditSubcategoria?.data?.data;
    const error = modelEditSubcategoria?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckUpdateSubcategoria.actions.clear());
    }
    if (data) {
      history.goBack();
      dispatch(controller.duckUpdateSubcategoria.actions.clear());
    }
  }, [modelEditSubcategoria]);

  useEffect(() => {
    const data = modelServicioById?.data?.data?.data;
    const error = modelServicioById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosById.actions.clear());
    }
    if (data) {
      setNombre(data.nombre);
      setEstado(data.estado);
      dispatch(controller.duckServiciosById.actions.clear());
    }
  }, [modelServicioById]);

  function submit() {
    if (!nombre || !estado) {
      alert("Por favor complete todos los campos");
      return;
    }

    let data = {
      id: match.params.id,
      nombre,
      estado,
    };
    dispatch(controller.updateSubcategoriaThunk(data));
  }

  return (
    <Content
      title="Editar subcategoria"
      browserTitle="Editar subcategoria"
      show={false}
    >
      <Row style={{ marginBottom: 20 }}>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar subcategoria"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.goBack();
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelEditSubcategoria.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelEditSubcategoria.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
                     <ReferenciaObligatorios />
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
            <Text
              labelPosition="above"
              size="sm"
              label={
                <Etiqueta texto="Nombre de la subcategoría" obligatorio={true} />
              }
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default EditSubcategoria;
